import React from 'react';
import TextField from '../../../../components/common/TextField';
import { SelectBox } from '../../../../components/common/SelectBox';

import { formatNumber } from '../../../../common/Util';
import ItemTitleSection from './ItemTitleSection';

/*		 
이름 : v.htm038
관계 : familyCode[v.htm002]
주민등록번호 : v.htm001
의료증빙코드 : htm006
지급처 : htm001
지급처 사업자번호 : htm002
건수 : htm007
금액 : htm016
*/
const MedicalDetailItem = ({
  inputList,
  data,
  handleChange,
  dataIndex,
  codeList,
  t,
  handleDeleteButton,
  disabled,
}) => {
  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      {inputList.map((item, index) => {
        if (item.input === 'selectBox') {
          return (
            <React.Fragment key={index}>
              <ItemTitleSection
                disabled={disabled}
                title={`${t('detail.title1')}${dataIndex + 1}`}
                handleDeleteButton={() => handleDeleteButton(dataIndex)}
              />
              <SelectBox
                label={item.label}
                name={item.key}
                onChange={e => handleChange(e, item, dataIndex)}
                value={data[item.key]}
                disabled={disabled}>
                {codeList(disabled)}
              </SelectBox>
            </React.Fragment>
          );
        } else {
          return (
            <TextField
              key={item.key}
              label={item.label}
              size="small"
              color={item.color}
              variant={item.variant}
              value={item.isNumber ? formatNumber(data[item.key]) : data[item.key]?.trim()}
              name={item.key}
              onChange={e => handleChange(e, item, dataIndex)}
              disabled={item.disabled || disabled}
              inputStyle={{
                backgroundColor: item.color === 'secondary' ? 'var(--Primary-100)' : '',
              }}
            />
          );
        }
      })}
    </div>
  );
};

export default MedicalDetailItem;
